import Vue from 'vue'

export const notificationBus = new Vue()

/**
 * How a notification is presented to the user.
 * - SNACKBAR: default, transient toast in the corner (auto-dismiss).
 * - BLOCKING: centered modal that blocks interaction until the user confirms.
 */
export const NOTIFICATION_PRESENTATION = Object.freeze({
  SNACKBAR: 'snackbar',
  BLOCKING: 'blocking'
})

const DEFAULT_TIMEOUT = 4000

/**
 * Notify user.
 *
 * @param {string} message
 * @param {Object} [options]
 * @param {number} [options.timeout]      Auto-dismiss delay (snackbar only).
 * @param {string} [options.type]         Severity, e.g. 'error' | 'success'.
 * @param {string} [options.presentation] One of NOTIFICATION_PRESENTATION.
 * @param {string} [options.title]        Optional title (blocking only).
 */
export function notify (message, options = {}) {
  notificationBus.$emit('notify', {
    id: Date.now() + Math.random(),
    message,
    timeout: options.timeout ?? DEFAULT_TIMEOUT,
    type: options.type ?? 'error',
    presentation: options.presentation ?? NOTIFICATION_PRESENTATION.SNACKBAR,
    title: options.title ?? ''
  })
}
